import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import { persistor, store } from "./_helpers";
import { ConfigProvider } from "antd";
import dayjs from "dayjs";
import isLeapYear from "dayjs/plugin/isLeapYear"; // import plugin
import "dayjs/locale/zh-cn"; // import locale
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";

import "./assets/css/bootstrap.min.css";
import "./assets/css/icons.min.css";
import "./App.scss";

// Suppress ReactQuill findDOMNode warning in development
// This is a known issue with ReactQuill and React 18 StrictMode
// See: https://github.com/zenoamaro/react-quill/issues/122
if (import.meta.env.DEV) {
  const originalError = console.error;
  console.error = (...args) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes('findDOMNode')
    ) {
      return;
    }
    originalError.call(console, ...args);
  };
}

dayjs.extend(isLeapYear); // use plugin
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.locale("zh-cn"); // use locale

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <ConfigProvider theme={{ token: { colorPrimary: "#3251d3" } }}>
            <App />
          </ConfigProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
